import { createSlice } from "@reduxjs/toolkit";
import { archiveLogHour, getLogHourList, logHourRequestLists } from "./_logHourAction";


interface LogHourState {
  logHourList: any[];
  loading: boolean;
  error: string | null;
  totalCount: number;
  logHourRequestList: any[];
}

const initialState: LogHourState = {
  logHourList: [],
  loading: false,
  error: null,
  totalCount: 0,
  logHourRequestList: [],
};


export const logHourReducer = createSlice({
  name: "logHour",
  initialState: initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Log Hour List
      .addCase(getLogHourList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLogHourList.fulfilled, (state, action) => {
        state.loading = false;
        state.logHourList = action.payload?.data;
        state.totalCount = action.payload?.count;
      })
      .addCase(getLogHourList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // Fetch Log Hour request List
      .addCase(logHourRequestLists.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(logHourRequestLists.fulfilled, (state, action) => {
        state.loading = false;
        state.logHourRequestList = action.payload?.data;
        state.totalCount = action.payload?.count;
      })
      .addCase(logHourRequestLists.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // Archive logHour
      .addCase(archiveLogHour.fulfilled, (state, action) => {
        state.logHourList = state.logHourList.filter((logHour) => logHour?.uuid !== action.payload?.data?.uuid);
      })
      .addCase(archiveLogHour.rejected, (state, action) => {
        state.error = action.payload as string;
      })
  },

});


export const { clearError } = logHourReducer.actions;
export default logHourReducer;